import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
// @ts-expect-error -- untyped module
import mfaSendOtp from "@/assets/mfa-send-otp.svg";
// import {  MfaViewState } from "@/pages/containers/mfa-container";
import { useContext } from "react";
import useUserInfo from "@/hooks/use-user-info";
import { useMMfaSetupOtp } from "@/hooks/use-mfa";
import useAuth from "@/context/auth-provider";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";

const RequestOTP = () => {
  const { setViewState, setSignature, email } = useContext(MFAContext);
  const { authData } = useAuth();
  const userInfoQuery = useUserInfo();
  const mfaSetupOtpQuery = useMMfaSetupOtp();

  const handleMfaSetupOtp = () => {
    mfaSetupOtpQuery.mutate(
      {
        divisionId: userInfoQuery.divisionId,
        groupId: userInfoQuery.groupId,
        loginGroupId: userInfoQuery.loginGroupId,
        username: userInfoQuery.username,
        accessToken: authData?.user.access_token,
        email,
      },
      {
        onSuccess: (response) => {
          if (response.success) {
            setSignature(response.signature);
            setViewState(MfaViewState.SEND_OTP);
          } else {
            setViewState(MfaViewState.REQUEST_OTP);
          }
        },
      },
    );

    // setViewState(MfaViewState.SEND_OTP);
  };

  return (
    <div className="flex h-[300px] flex-col justify-between gap-8 text-center sm:w-auto lg:w-[260px]">
      <div className="grid grid-cols-1 place-items-center gap-6">
        <img src={mfaSendOtp} className="size-20" alt="" />
        <Label className="text-lg font-bold">Send OTP</Label>
        <div className="flex flex-col gap-1 text-center">
          <Label className="text-sm/6">
            We will send One Time Password to your Email.
          </Label>
          <Label className="font-bold">{email}</Label>
        </div>
      </div>
      <div className="flex justify-center gap-4">
        <Button
          type="submit"
          className="w-32 rounded-sm"
          onClick={handleMfaSetupOtp}
          disabled={mfaSetupOtpQuery.isPending}
        >
          {mfaSetupOtpQuery.isPending ? "Requesting..." : "Request OTP"}
        </Button>
      </div>
    </div>
  );
};

export default RequestOTP;
